import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-topbar-cadastro',
  templateUrl: './topbar-cadastro.component.html',
  styleUrls: ['./topbar-cadastro.component.css']
})
export class TopbarCadastroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
